export default __webpack_public_path__ + "assets/8.986facd0.png";